import React from 'react';
import classnames from 'classnames';
import { orderBy } from 'lodash';

import Show from 'components/Show';
import Tooltip from 'components/Ui/Tooltip';
import { FinalMark } from 'components/Ui/Mark';

import Course from 'containers/Student/Marks/Summary/Course';

import { useStudentMarkStore } from 'store/student/useStudentMarkStore';

const Subject = ({ subject }) => {
	// Use student's mark store
	const [courses, final, middle, transferred] = useStudentMarkStore(state => [
		orderBy(state.courses.filter(course => course.gradeId === state.active && course.subjectId === subject.id && !course.additional), 'startDate'),
		state.marks.find(mark => mark.gradeId === state.active && mark.subjectId === subject.id && mark.type === 'final'),
		state.marks.find(mark => mark.gradeId === state.active && mark.subjectId === subject.id && mark.type === 'middle'),
		state.marks.filter(mark => mark.gradeId === state.active && mark.subjectId === subject.id && mark.type === 'transferred')
	]);

	// Concat data cell classname
	const cls = classnames(
		'p-2 first:pl-3 text-neutral-700 dark:text-neutral-200 text-sm font-bold',
		'border-neutral-100 dark:border-neutral-700',
		'first:border-l border-r border-b',
		'group-one:first:rounded-bl-lg',
		'group-one:last:rounded-br-lg',
		'group-two-last:first:rounded-bl-lg',
		'group-two-last:last:rounded-br-lg'
	);

	return (
		<>
			<tr className="group-one hidden md:table-row">
				{/* Subject's title */}
				<td className={cls}>
					{subject.title}
				</td>

				{/* Module marks */}
				<td className={cls}>
					<div className="flex flex-wrap gap-2">
						{transferred?.map(mark =>
							<FinalMark
								key={mark?.id}
								mark={mark}
							/>
						)}

						{courses?.map(course =>
							<Course key={course.id} course={course} />
						)}
					</div>
				</td>

				{/* Either final mark or middle mark */}
				<td className={cls}>
					<div className="flex flex-wrap gap-2">
						<Show if={final}>
							<Tooltip content={() =>
								<div className="py-1 px-2 bg-white text-neutral-700 whitespace-nowrap rounded-lg">
									<div className="text-sm font-bold text-neutral-700">
										Gala vērtējums
									</div>
								</div>
							}>
						
								<FinalMark
									mark={final}
								/>
							</Tooltip>
						</Show>

						<Show if={middle}>
							<Tooltip content={() =>
								<div className="py-1 px-2 bg-white text-neutral-700 whitespace-nowrap rounded-lg">
									<div className="text-sm font-bold text-neutral-700">
										Starpvērtējums
									</div>
								</div>
							}>
								<FinalMark
									mark={middle}
								/>
							</Tooltip>
						</Show>
					</div>
				</td>
			</tr>

			{/* Mobile view */}
			<tr className="group-two table-row md:hidden">
				<td colSpan="3" className={cls}>
					{subject.title}
				</td>		
			</tr>

			<tr className="group-two table-row md:hidden">
				{/* Module marks */}
				<td colSpan="2" className={cls}>
					<div className="flex flex-wrap gap-2">
						{courses?.map(course =>
							<Course key={course.id} course={course} />
						)}
					</div>
				</td>

				{/* Either final mark or middle mark */}
				<td className={cls}>
					<div className="flex flex-wrap gap-2">
						<Show if={final}>
							<FinalMark
								mark={final}
							/>
						</Show>

						<Show if={middle}>
							<FinalMark
								mark={middle}
							/>
						</Show>
					</div>
				</td>
			</tr>
		</>
	);
};

export default Subject;